






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { format } from 'date-fns';
import ruLocale from 'date-fns/locale/ru';
import { chunk } from 'lodash';
import { Card } from './compopnents';

@Component({
  components: {
    Card,
    Slider: () => import('@/pages/profile/components/slider'),
  },
})
export default class Info extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Array<any>;

  @Prop({ type: Boolean, default: true })
  readonly showAddition: boolean;

  @Prop({ type: Boolean, default: false })
  readonly noborder!: boolean;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: Number, default: 5 })
  readonly step!: number;

  get isCaruselData() {
    const { info, noborder, step } = this;
    return !noborder && info.length > step;
  }

  get info() {
    return this.items.map(({ date, items }) => ({
      date: date.length
        ? format(date, 'D MMMM YYYY', { locale: ruLocale })
        : '',
      noFormatDate: date,
      items,
    }));
  }

  get caruselData() {
    const { info, isCaruselData, step } = this;
    return isCaruselData && chunk(info, step);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/Info.vue